import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  Injector,
  input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { isNumberHasValue } from '@const';
import { VideoHubPlayer } from '@t/video-hub/video-hub-player.interface';
import Player from '@vimeo/player';

@Component({
  selector: 'app-vimeo-player',
  imports: [],
  templateUrl: './vimeo-player.component.html',
  styleUrl: './vimeo-player.component.scss',
})
export class VimeoPlayerComponent implements OnInit, AfterViewInit, VideoHubPlayer {
  @ViewChild('vimeoPlayerContainer', { static: true }) vimeoPlayerContainer!: ElementRef<HTMLDivElement>;
  public videoUrl = input.required<string>();
  public videoStartTime = input<number>();
  @Output()
  public videoEnd = new EventEmitter<void>();
  @Output()
  public videoLoaded = new EventEmitter<void>();
  private player: Player | undefined;
  private isPlayerReady = false;

  constructor(private injector: Injector) {}

  ngOnInit(): void {
    effect(
      () => {
        if (this.videoUrl()) {
          this.player?.destroy();
          this.configurePlayer();
        }
      },
      { injector: this.injector },
    );

    effect(
      () => {
        const time = this.videoStartTime();
        if (isNumberHasValue(time) && this.isPlayerReady) {
          this.player?.setCurrentTime(time);
        }
      },
      { injector: this.injector },
    );
  }

  ngAfterViewInit(): void {
    // configurePlayer теперь вызывается при каждом изменении videoUrl
  }

  public async getVideoUrl(): Promise<string> {
    try {
      const timestamp = await this.player?.getCurrentTime();
      return this.videoUrl() + `#t=${timestamp ?? 0}s`;
    } catch {
      return '';
    }
  }

  public pause(): void {
    this.player?.pause();
  }

  public async getCurrentTime(): Promise<number> {
    try {
      return Math.trunc((await this.player?.getCurrentTime()) ?? 0);
    } catch {
      return 0;
    }
  }

  public async setCurrentTime(currentTime: number): Promise<number> {
    return this.player?.setCurrentTime(currentTime);
  }

  public async play(): Promise<void> {
    return this.player?.play();
  }

  private onVideoEnd(): void {
    this.videoEnd.emit();
  }

  private onVideoLoaded(): void {
    this.isPlayerReady = true;
    const time = this.videoStartTime();
    if (isNumberHasValue(time)) {
      this.player?.setCurrentTime(time);
    }
    this.videoLoaded.emit();
  }

  private configurePlayer(): void {
    const container = this.vimeoPlayerContainer?.nativeElement;
    if (!container) {
      console.error('Vimeo player container not found');
      return;
    }
    // Очищаем контейнер перед созданием нового плеера
    container.innerHTML = '';
    this.isPlayerReady = false;
    this.player = new Player(container, {
      url: this.videoUrl(),
      start_time: this.videoStartTime() ?? 0,
      responsive: true,
      pip: false,
      byline: false,
      cc: false,
      portrait: false,
      title: false,
      vimeo_logo: false,
      interactive_markers: false,
      autoplay: true,
      volume: false,
      transcript: false,
      quality_selector: false,
      speed: false,
    });
    this.player.on('ended', this.onVideoEnd.bind(this));
    this.player.on('loaded', this.onVideoLoaded.bind(this));
  }
}
